// src/app/store.js
import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './rootReducer.js'

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST'],
            },
        }),
})

export default store